export default function () {
  return {
    position: null,
    permission: null,
  }
}
